import { defineComponent, reactive } from '@vue/composition-api'
import './index.scss'
const StarScore = defineComponent({
  props: {
    minScoreDesc: {
      type: String,
      default: '很不满意'
    },
    maxScoreDesc: {
      type: String,
      default: '很满意'
    },
    maxScore: {
      type: Number,
      default: 10
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Number, String],
      default: ''
    },
    isNps: {
      type: Boolean,
      default: false
    },
    topicSetting:{
      type:Object,
    }
  },
  setup(props, context) {
    //根据分辨率来区分布局
    const isMini = document.body.clientWidth < 1000
    const { emit } = context
    const state = reactive({
      hoverValue: props.value,
      hadClick: false
    })
    const changeScore = (value) => {
      state.hadClick = true
      if (props.isNps &&  value) {
        emit('updateValue', value - 1)
      } else {
        emit('updateValue', value)
      }
    }

    const isDataAnalysis = ()=>{
      return [
        '/v2/front/dataAnalysis/surveyData/detail',
        '/v2/front/dataAnalysis/userData/detail',
        '/v2/front/survey/answerInfo',
        '/v2/front/dataAnalysis/surveyData'
      ].includes(window.location.pathname)
    }

    return () => {
      return isMini ? (
        <div class="star-score">
          {props.showTitle && <div class="bar-score-top">
          <span
              class={{
                'star-score-bad':
                  props.value == (props.isNps ? 0 : 1) && state.hadClick
              }}>
              {props.minScoreDesc}
            </span>
            <span style={{flex:1}}></span>
            <span
              class={{
                'star-score-good':
                  props.value == (props.isNps ? 10 : props.maxScore) &&
                  state.hadClick
              }}>
              {props.maxScoreDesc}
            </span>
            {/* 根据后端条件判断要不要渲染 */
              !!props?.topicSetting?.customizeOption && <div class='cust-title'>{props?.topicSetting?.customizeOptionValue}</div>
            }
          </div>
          }
          <div class="bar-score-middle small-rate">
          <el-rate
            onchange={(value) => changeScore(value)}
            max={props.isNps ? 11 : props.maxScore}
            value={
              props.isNps
                ? (state.hadClick || isDataAnalysis())
                  ? +props.value + 1
                  : +props.value
                : +props.value
            }></el-rate>
          {/* 根据后端条件判断要不要渲染 */
            !!props?.topicSetting?.customizeOption &&
            <el-radio
              // key='npsRadio'
              label={`-1:${props?.topicSetting?.customizeOptionValue}`}
              value={props.value}
              onInput={(value)=>{
                emit('updateValue', value)
              }}
            >
            </el-radio>
          }
          </div>
        </div>
      ) : (
        <div class="star-score">
          {props.showTitle && <div class="bar-score-top">
          <span
              class={{
                'star-score-bad':
                  props.value == (props.isNps ? 0 : 1) && state.hadClick
              }}>
              {props.minScoreDesc}
            </span>
            <span style={{flex:1}}></span>
            <span
              class={{
                'star-score-good':
                  props.value == (props.isNps ? 10 : props.maxScore) &&
                  state.hadClick
              }}>
              {props.maxScoreDesc}
            </span>
            {/* 根据后端条件判断要不要渲染 */
              !!props?.topicSetting?.customizeOption && <div class='cust-title'>{props?.topicSetting?.customizeOptionValue}</div>
            }
          </div>
          }
          <div class="bar-score-middle">
          <el-rate
            onchange={(value) => changeScore(value)}
            max={props.isNps ? 11 : props.maxScore}
            value={
              props.isNps
                ? (state.hadClick || isDataAnalysis())
                  ? +props.value + 1
                  : +props.value
                : +props.value
            }></el-rate>
          {/* 根据后端条件判断要不要渲染 */
            !!props?.topicSetting?.customizeOption &&
            <el-radio
              // key='npsRadio'
              label={`-1:${props?.topicSetting?.customizeOptionValue}`}
              value={props.value}
              onInput={(value)=>{
                emit('updateValue', value)
              }}
            >
            </el-radio>
          }
          </div>
        </div>
      )
    }
  }
})
export default StarScore
